export default __webpack_public_path__ + "static/media/other.dfc34454.svg";